const ru = {
    login: "Войти",
    logout: "Выйти",
    signIn: "Вход",
    signOut: "Выход",
    profile: "Профиль",
    settings: "Настройки",
    digiAirMenuWaiterLogin: "Вход официанта DigiAirMenu",
    username: "Имя пользователя",
    password: "Пароль",
    pinCode: "PIN-код",
    yourAuthenticationFailed: "Не удалось выполнить вход",
    language: "Язык",
    chooseLanguage: "Выбрать язык",
    pageNotFound: "Страница не найдена",
    backToDashboard: "Вернуться к панели",
    currentTable: "Текущая таблица",
    table: "Стол",
    tables: "Столы",
    order: "Заказ",
    orders: "Заказы",
    option: "Опция",
    additive: "Добавка",
    options: "Опции",
    additives: "Добавки",
    empty: "Пусто",
    untitledItem: "Без названия",
    createdAt: "Создано",
    free: "Бесплатно",
    items: "позиции",
    item: "позиция",
    itemsCountOfAll: "{{payCount}} из {{maxCount}}",
    minimum: "минимум",
    maximum: "максимум",
    all: "Все",
    unitPrice: "Цена за единицу",
    email: "Эл. почта",
    print: "Печать",
    printingFailed: "Не удалось напечатать!",
    orderDetails: "Детали заказа",
    noOrders: "Нет заказов",
    noOrdersAdded: "Заказы не добавлены",
    noAddedItems: "Позиции не добавлены",
    loading: "Загрузка",
    createOrSelectOrderAfterSelectingTable: "Сначала выберите стол, затем создайте или выберите заказ",
    createOrSelectOrderFirst: "Сначала создайте или выберите заказ",
    customFood: "Пользовательская позиция",
    customFoods: "Пользовательские позиции",
    normalFoodOrDrink: "обычное блюдо/напиток",
    customMenuItems: "Пользовательские позиции меню",
    sentToKitchen: "Отправлено на кухню",
    sendToKitchen: "Отправить на кухню",
    orderDelivered: "Заказ доставлен",
    type: "тип",
    status: "статус",
    paid: "оплачено",
    partiallyPaid: "Частично оплачено",
    unpaid: "не оплачено",
    pending: "В ожидании",
    canceled: "Отменено",
    created: "Создано",
    accepted: "Принято",
    completed: "Завершено",
    total: "Итого",
    editOrderItem: "Изменить позицию заказа",
    chooseTable: "Выбрать стол",
    pickup: "Самовывоз",
    suspended: "Приостановлено",
    processing: "Готовится",
    rejected: "Отклонено",
    delivered: "Доставлено",
    ordersList: "Список заказов",
    showOlderOrders: "Показать старые заказы",
    showHistory: "Показать историю",
    showCanceledOrders: "Показать отменённые заказы",
    showDeliveredOrders: "Показать доставленные заказы",
    showPaidOrders: "Показать оплаченные заказы",
    addNewOrder: "Добавить заказ",
    ordering: "Оформление заказа",
    availableFoods: "Доступные позиции",
    searchByTableName: "Поиск по названию стола",
    gridView: "Сетка",
    listView: "Список",
    Filters: "Фильтры",
    availableItems: "Доступные позиции",
    searchByFoodName: "Поиск по названию блюда",
    allCategories: "Все категории",
    noCategories: "Нет категорий",
    addFood: "Добавить позицию",
    editManualItem: "Изменить ручную позицию",
    addManualItem: "Добавить ручную позицию",
    manualItem: "Ручная позиция",
    manualItems: "Ручные позиции",
    sendEmail: "Отправить письмо",
    send: "Отправить",
    resendPaymentLink: "Отправить ссылку оплаты повторно",
    iUnderstand: "Я понимаю",
    no: "Нет",
    yes: "Да",
    cancel: "Отмена",
    close: "Закрыть",
    back: "Назад",
    next: "Далее",
    previous: "Назад",
    add: "Добавлять",
    preview: "Предпросмотр",
    changeTable: "Сменить стол",
    saveChanges: "Сохранить изменения",
    confirm: "Подтвердить",
    selectAll: "Выбрать всё",
    unselectAll: "Снять выбор",
    clear: "Очистить",
    accept: "Принять",
    acceptOrder: "Принять заказ",
    confirmOrder: "Подтвердить заказ",
    rejectOrder: "Отклонить заказ",
    pay: "Оплатить",
    payment: "Оплата",
    payments: "Оплаты",
    paymentOf: "Оплата заказа",
    itemsToPay: "Позиции к оплате",
    price: "Цена",
    basicPrice: "Базовая цена",
    totalPrice: "Итоговая цена",
    discount: "Скидка",
    tip: "Чаевые",
    payByCreditCard: "Оплата картой",
    payInCash: "Оплата наличными",
    checkout: "Касса",
    transaction: "Транзакция",
    transactionDetails: "Детали транзакции",
    paymentType: "Тип оплаты",
    paymentStatus: "Статус оплаты",
    totalAmount: "Общая сумма",
    openPayments: "Открытые оплаты",
    openPaymentsReport: "Отчёт по открытым оплатам",
    thisItemPaymentIsAwaitingConfirmation: "Оплата этой позиции ожидает подтверждения",
    yourOrderPaymentIsAwaitingConfirmation: "У этого заказа есть оплата, ожидающая подтверждения",
    editableInTime: "Можно изменить через {{minutes}} мин {{seconds}} с",
    generalSettings: "Общие настройки",
    printMethod: "Способ печати",
    printMethodBrowser: "Окно печати браузера",
    printMethodBluetooth: "Bluetooth-принтер",
    printMethodUsb: "USB-принтер (экспериментально)",
    printMethodExternal: "Внешний принтер / приложение",
    autoPrint: "Автопечать",
    virtualKeyboard: "Виртуальная клавиатура",
    delivery: "Доставка",
    deliveryAddress: "Адрес доставки",
    deliveryDetails: "Детали доставки",
    addDeliveryDetails: "Добавить детали доставки",
    editDeliveryDetails: "Изменить детали доставки",
    createDelivery: "Создать доставку",
    fullAddress: "Полный адрес",
    postalCode: "Почтовый индекс",
    houseNumber: "Номер дома",
    doorNumber: "Номер двери",
    floor: "Этаж",
    fullName: "Полное имя",
    phoneNumber: "Номер телефона",
    deliverySummary: "Сводка доставки",
    Error: "Ошибка",
    unexpectedErrorOccurred: "Произошла ошибка",
    distance: "Расстояние",
    duration: "Длительность",
    minutes: "Минуты",
    deliveryPrice: "Стоимость доставки",
    deliveryFee: "Плата за доставку",
    itemsPrice: "Стоимость позиций",
    totalReceipt: "Итого по чеку",
    customer: "Клиент",
    pickupDetails: "Детали самовывоза",
    pickupDate: "Дата самовывоза",
    pickupTime: "Время самовывоза",
    pickupDatetime: "Запрошенные дата/время самовывоза",
    orderId: "ID заказа",
    orderStatus: "Статус заказа",
    waiter: "Официант",
    fromCustomerApp: "Из приложения клиента",
    orderType: "Тип заказа",
    sendDelivery: "Отправить доставку",
    requestCourier: "Вызвать курьера",
    callCourier: "Позвонить курьеру",
    somethingWentWrong: "Что-то пошло не так",

    appLogoAlt: "логотип digiAirMenu",
    addDAMToHomeScreen: "Добавить DigiAirMenu на главный экран",
    addToHomeScreen: "Добавить на главный экран",
    installDAM: "Установить DAM",
    transferToDemo: "Переключить в демо",
    transferToLive: "Переключить в рабочий режим",
    row: "Строка",
    count: "количество",
    step: "шаг",
    title: "Название",
    freeItems: "бесплатные позиции",
    min: "мин",
    max: "макс",
    checkoutPrintDataUnavailable: "Данные платежного чека недоступны для печати",
    printUsingExternalDevice: "Печать через внешнее устройство",
    orderDeliveredConfirmation: "Вы уверены, что этот заказ был передан?",
    selectItemsForSendingToKitchen: "Выберите позиции для отправки на кухню",
    ItemDetailsAndStatus: "Детали / статус позиции",
    description: "описание",
    typeAnythingYouNeed: "Введите всё, что нужно",
    arrival: "Прибытие",
    late_arrival: "Опоздание прибытия",
    late_pickup: "Опоздание самовывоза",
    request_new_driver: "Запросить нового водителя",
    shipment_destroyed: "Отправление повреждено",
    address_not_found: "Адрес не найден",
    late_completed: "Завершено с опозданием",
    isPaid: "Оплачено",
    listOfOrders: "Список заказов",
    listOfolderOrRejectedOrdersTitle: "Старые/отклоненные",
    Layout: "Макет",
    areYouSureYouWantToConvertOrderToDemoModeOrder: "Вы уверены, что хотите преобразовать заказ <1>{{orderId}}</1> в демо-заказ?",
    areYouSureYouWantToConvertOrderToLiveModeOrder: "Вы уверены, что хотите преобразовать заказ <1>{{orderId}}</1> в рабочий заказ?",
    areYouSureYouWantToSwitchToLiveMode: "Вы уверены, что хотите переключиться в рабочий режим?",
    areYouSureYouWantToSwitchToDemoMode: "Вы уверены, что хотите переключиться в демо-режим?",
    areYouWantDeleteThisItem: "Вы уверены, что хотите удалить эту позицию?",
    areYouWantCancelOrder: "Вы уверены, что хотите отменить этот заказ?",
    getEmailLabel: "Введите e-mail",
    enterValidEmailErr: "Введите корректный e-mail.",
    sendReceiptInfo: "Отправить детали чека",
    sendMenuSms: "Отправить ссылку на меню",
    sendMenuLinkBySms: "Отправить ссылку на меню по SMS",
    menuLinkSentSuccessfully: "Ссылка на меню успешно отправлена",
    paymentLinkResentSuccessfully: "Ссылка на оплату успешно отправлена",
    receiverEmail: "E-mail получателя",
    receiverPhone: "Телефон получателя",
    receiverEmailPlaceholder: "example@email.com",
    emailIsRequired: "E-mail обязателен",
    phoneNumberIsRequired: "Номер телефона обязателен",
    emailOrPhoneIsRequired: "E-mail или номер телефона обязателен",
    invalidEmailFormat: "Некорректный формат e-mail",
    selected: "выбрано",
    reset: "Сбросить",
    mobileKeyboard: "Мобильная клавиатура",
    externalDeliveryOrder: "Внешний заказ доставки",
    externalDeliveryOrderDescription: "Этот заказ нужно принять перед обработкой",
    waiterDraftOrder: "Заказ, созданный официантом",
    waiterDraftOrderDescription: "Вы всё еще можете изменить этот заказ. Подтвердите его, когда всё будет готово.",
    completeOrderSetup: "Завершить настройку заказа",
    completeOrderSetupDialogTitle: "Заполните данные доставки и подтвердите время заказа",
    acceptOrderDialogTitle: "Принятие заказа запустит приготовление и уведомит кухню",
    confirmOrderDialogTitle: "Подтверждение заказа заблокирует изменения и запустит приготовление",
    acceptOrderExternalDescription: "Этот заказ поступил извне. Примите его, чтобы начать приготовление, или отклоните, если не можете выполнить.",
    confirmOrderWaiterCreatedDescription: "Этот заказ создан официантом. Проверьте и подтвердите его, когда все позиции готовы.",
    acceptOrderWaiterCreatedDescription: "Этот заказ создан официантом. Примите его, чтобы заблокировать изменения и начать приготовление.",
    editingLockedForCustomerOrder: "Редактирование заказов клиента заблокировано.",
    editingLockedForRejectedOrder: "Редактирование заблокировано, потому что заказ был отклонен.",
    editingLockedCustomerOrderAfterAcceptance: "Редактирование заказов клиента блокируется после принятия.",
    editingLockedAfterConfirmation: "Редактирование заблокировано после подтверждения заказа.",
    editingDoneOrderItemLocked: "Готовые позиции больше нельзя изменить.",
    editingPaidOrderItemLocked: "Оплаченные позиции больше нельзя изменить.",
    editingPendingPaymentOrderItemLocked: "Эту позицию нельзя изменить во время обработки платежа.",
    editingSentToKitchenItemLockedByPermission: "У вас нет прав изменять позиции, уже отправленные на кухню.",
    rejectOrderConfirm: "Вы уверены, что хотите отклонить этот заказ?",
    acceptOrderPickupTimeHelperText: "Вы можете отложить время самовывоза до <1>30 минут</1>",
    pleaseEnterPickupTime: "Введите время самовывоза",
    addToOrders: "добавить к заказам",
    cancelThisOrder: "Отменить этот заказ",
    cancelOrder: "Отменить заказ",
    orderModeChangedToDemoInJSX: "Нужный режим заказа изменен на демо с названием '<1>Заказ {{targetOrderId}}</1>'.",
    orderModeChangedToLiveInJSX: "Нужный режим заказа изменен на рабочий с названием '<1>Заказ {{targetOrderId}}</1>'.",
    checkoutHasPaidByPosInJSX: "<1>Оплата</1> с id <3>{{checkout_id}}</3> из <5>заказа {{order_id}}</5> успешно прошла через POS.",
    demo: "Демо",
    demoModeIsActive: "Демонстрационный режим активен",
    demoModeAlertMessage: "Демонстрационный режим предназначен исключительно для обучения и тестирования. Оператор ресторана несет полную ответственность за использование системы и соблюдение всех применимых правовых норм во время работы демонстрационного режима.",
    normal: "Обычный",
    showOrderInTargetMode: "Показать заказ в режиме {{targetMode}}",
    showOrder: "Показать заказ",
    openOrderInBackground: "<0>Открыть</0> <1>(в фоне)</1>",
    incomingOrderNotificationTitle: "Получен новый заказ",
    incomingOrderNotificationDescription: "Поступил заказ клиента. Используйте кнопку ниже, чтобы открыть его в фоне, не закрывая это окно.",
    yesDeleteIt: "Да, удалить",
    payReport: "Отчет по оплатам",
    checkoutOperation: "Операция оплаты",
    baseAmount: "Базовая сумма",
    paidPrice: "Оплаченная сумма",
    paidBy: "Оплатил",
    discountAmount: "Сумма скидки",
    tipPrice: "Чаевые",
    totalWithTip: "Итого с чаевыми",
    amountToPay: "Сумма к оплате",
    paymentAmount: "Сумма платежа",
    paymentsIncludingDiscounts: "Оплаты с учетом скидок",
    paymentsExcludingDiscounts: "Оплаты без скидок",
    paymentsTakingIntoAccountTheirDiscount: "Оплаты с учетом своей скидки",
    paymentsRegardlessOfTheirDiscount: "Оплаты без учета своей скидки",
    openPaymentsStatistics: "Статистика открытых оплат",
    discountCannotBeLessThanZero: 'Скидка не может быть меньше "0"',
    discountCannotBeNegative: "Скидка не может быть отрицательной",
    discountCannotBeMoreThanHundredPercent: 'Скидка не может быть больше "100%"',
    discountCannotBeMoreThan: "Скидка не может быть больше {{price}}",
    theValueMustBeMoreThan: "Значение должно быть больше {{price}}",
    theValueMustBeMoreThanBaseAmount: "Значение должно быть больше базовой суммы",
    valueMustBeLessThanOrEqualToMessage: "Значение должно быть меньше или равно {{maxPrice}}",
    valueMustBeGreaterThanZeroMessage: "Значение должно быть больше 0",
    tipAmount: "Сумма чаевых",
    tipCannotBeNegative: "Сумма чаевых не может быть отрицательной",
    cardTransfer: "Перевод на карту",
    noTransactionHasBeenMade: "Транзакций не было",
    backToTransactionsList: "Назад к списку транзакций",
    transactionsHistory: "История транзакций",
    transactionId: "ID транзакции",
    transactionHasBeenSentToYourEmail: "Транзакция отправлена на ваш e-mail",
    ordersPrice: "Сумма заказов",
    updatedAt: "Обновлено",
    fromTime: "С",
    toTime: "До",
    backToOrders: "Назад к заказам",
    tablesList: "Список столов",
    backToTablesList: "Назад к списку столов",
    showDetails: "Показать детали",
    receiptDetailsPage: "Страница деталей чека",
    checkoutQrCodeAlt: "QR-код оплаты",
    vat: "НДС",
    net: "Нетто",
    tax: "Налог",
    gross: "Брутто",
    sendingEmailFailed: "Не удалось отправить e-mail!",
    paymentFailed: "Оплата не прошла",
    Open_Payments: "Открытые оплаты",
    report: "Отчет",
    openPaymentStatistics: "Статистика открытой оплаты",
    allOrderItemsHaveBeenPaid: "Все позиции этого заказа оплачены",
    noItemsHaveBeenAddedInThisOrder: "В этот заказ не добавлены позиции",
    thisItemHasBeenPaidThroughPOSAndIsAwaitingPaymentConfirmation: "Эта позиция оплачена через POS и ожидает подтверждения оплаты",
    yourOrderHasBeenPaidThroughPOSAndIsAwaitingPaymentConfirmation: "Ваш заказ оплачен через POS и ожидает подтверждения оплаты",
    customItems: "Пользовательские позиции",
    singlePrintMethodDescription: "Одновременно активен только один способ печати",
    bluetoothUnavailable: "Bluetooth недоступен в этом браузере или на этом устройстве",
    bluetoothSecureContextRequired: "Для Bluetooth-печати требуется HTTPS или localhost",
    bluetoothPrinterNotSupported: "Выбранный Bluetooth-принтер не поддерживается",
    noBluetoothPrinterSelected: "Bluetooth-принтер не выбран",
    noCompatibleBluetoothPrinterFound: "Совместимый Bluetooth-принтер не найден или не выбран. Браузеры обычно обнаруживают только BLE/GATT-принтеры, поэтому классические модели Bluetooth, например Epson TM-m30, могут здесь не отображаться",
    bluetoothAutoPrintRequiresSelection: "Выберите Bluetooth-принтер вручную один раз, прежде чем использовать автопечать",
    bluetoothPrintingNotSupported: "Bluetooth-печать не поддерживается в этом браузере или на этом устройстве",
    usbUnavailable: "USB недоступен в этом браузере или на этом устройстве",
    usbSecureContextRequired: "Для USB-печати требуется HTTPS или localhost",
    noCompatibleUsbPrinterFound: "Совместимый USB-принтер не найден или не выбран",
    usbAccessDenied: "Браузер или операционная система запретили доступ к выбранному USB-принтеру. Закройте другие приложения печати, проверьте системные разрешения USB и повторите попытку",
    usbAutoPrintRequiresSelection: "Выберите USB-принтер вручную один раз, прежде чем использовать автопечать",
    usbPrintingNotSupported: "USB-печать не поддерживается для выбранного устройства",
    printerSize: "Размер принтера",
    useExternalPrinter: "Использовать внешний принтер",
    bluetoothPrinterDetails: "Вы можете отправлять печать на Bluetooth-принтеры или отключить этот режим, чтобы выбрать принтер, подключенный к устройству",
    usbPrinterDetails: "Экспериментальная поддержка USB-принтеров ESC/POS в настольных Chrome или Edge. Возможно, потребуется один раз выбрать принтер вручную перед автопечатью. В Windows принтеру также может потребоваться режим Vendor Class и WinUSB-совместимый драйвер, чтобы появиться в списке браузера",
    externalPrinterDetails: "Вы можете отправлять печать на внешние принтеры, подключенные к приложению, или отключить этот режим, чтобы выбрать принтер, подключенный к устройству",
    autoPrintDescription: "Автоматически печатать после принятия заказа или после websocket-события оплаченного заказа",
    autoPrintUnavailableForBrowserDescription: "Автопечать недоступна при использовании окна печати браузера",
    browserPrintMethodNotice: "Окно печати браузера всегда требует подтверждения, поэтому чеки нельзя печатать автоматически",
    selectAllPayablesByDefault: "Выбирать все оплачиваемые позиции по умолчанию",
    selectAllPayablesByDefaultOnThePaymentPage: "Выбирать все оплачиваемые позиции на странице оплаты по умолчанию",
    virtualKeyboardDescription: "Использовать встроенную клавиатуру приложения в поддерживаемых полях",
    virtualKeyboardInfoLabel: "Справка по клавиатуре",
    virtualKeyboardDisableHint: "Если вы предпочитаете клавиатуру устройства, ее можно отключить в <0>Настройках</0>.",
    served: "Подано",
    apartmentEntrance: "Подъезд",
    extraAddressDetails: "Дополнительные детали адреса",
    dialCode: "Код страны",
    contactInformationAtPickup: "Контактные данные получателя",
    recommended: "рекомендуется",
    successfulDeliveryRegistration: "Доставка успешно зарегистрирована",
    successfulSendDelivery: "Доставка успешно отправлена",
    withDelivery: "С доставкой",
    deliveryItem: "Позиция доставки",
    pickupTimeLabel: "Время самовывоза ({{format}})",
    pickupTimeBaseLabel: "Базовое время самовывоза",
    pickupTimeFinalLabel: "Итоговое время самовывоза",
    dropOffTime: "Время передачи",
    requestedPickupDatetime: "Текущие запрошенные дата/время самовывоза",
    timePickerHour: "Час",
    timePickerMinute: "Минута",
    toggleTimeList: "Показать/скрыть список времени",
    pickupTimeInitialShort: "База",
    orderTiming: "Время заказа",
    maximumSelectableFreeCountHint: "Максимальное количество, которое можно выбрать бесплатно",
    minimumSelectableCountHint: "Минимальное выбираемое количество",
    maximumSelectableCountHint: "Максимальное выбираемое количество",
    maximumSelectedItemsReached: "Достигнуто максимальное количество выбранных позиций",
    changePickupTime: "Изменить время самовывоза",
    pickupTimeAllowedRangeHint: "Для {{date}} время самовывоза можно выбрать с {{start}} до {{end}}.",
    pickupDatetimeNotSetHint: "Дата/время самовывоза еще не заданы. Можно выбрать любое время самовывоза.",
    pickupDatetimeLimitedDelayHint: "Это запрошенное время самовывоза можно отложить до <1>30 минут</1>, пока заказ ожидает принятия.",
    pickupDatetimeLockedHint: "Для этого заказа уже задана дата/время самовывоза.",
    pickupTimeEditableOnlyWhenSuspended: "Время самовывоза можно изменить только когда заказ приостановлен.",
    pleaseEnterPickupDate: "Введите дату самовывоза",
    pickupDateMustBeTodayOrTomorrow: "Для заказов, созданных официантом, дата самовывоза должна быть сегодня или завтра.",
    normalOrderCreationUnavailableTitle: "Обычные заказы сейчас недоступны",
    normalOrderCreationClosedAllDay: "Ресторан закрыт в этот день, поэтому заказы создать нельзя.",
    normalOrderCreationClosedAtThisTime: "Ресторан сейчас закрыт. Заказы можно создавать в часы работы: {{hours}}.",
    waiterOrderNoAvailableOpenSlot: "Нет доступного времени {{orderType}} в часы работы ресторана для текущих разрешенных дат.",
    pickupDateOutsideOpeningHours: "Выбранная дата вне разрешенных рабочих дней для заказов {{orderType}}.",
    pickupTimeOutsideOpeningHours: "Выбранное время вне разрешенных часов для заказов {{orderType}}.",
    openingHoursSelectableRangeHint: "Для {{date}} время {{orderType}} можно выбрать с {{start}} до {{end}}.",
    openingHoursClosedDayHint: "{{date}} закрыт для заказов {{orderType}}.",
    openingHoursClosedDayCalendarHint: "Закрыто для этого типа заказа",
    openingHoursDisabledDatesHint: "Можно выбрать только даты, где есть хотя бы одно доступное время {{orderType}} в часы работы ресторана.",
    openingHoursUnavailableTimesHint: "Время, которое нельзя выбрать, вне часов работы ресторана для заказов {{orderType}} на выбранную дату.",
    deliveryAndPickupOrders: "Заказы доставки и самовывоза",
    payByLink: "Оплата по ссылке",
    updateDelivery: "Обновить доставку",
    sendCourierRequest: "Отправить запрос курьера",
    sentToCourier: "Отправлено курьеру",
    noPickupTimeProvidedForThisOrder: "Для этого заказа не указано время самовывоза",
    pickupTimeCalculationForThisOrderFailed: "Не удалось рассчитать время самовывоза для этого заказа",
    itemEditFailed: "Не удалось изменить позицию",
    thisItemCannotBeEdited: "Эту позицию нельзя изменить.",
    problemInReadingItemEssentialDataMessage: "Возникла проблема при чтении основной информации о позиции",
};

export default ru;
